import { render } from "./ImportPage.vue?vue&type=template&id=1c191c93"
import script from "./ImportPage.vue?vue&type=script&lang=js"
export * from "./ImportPage.vue?vue&type=script&lang=js"
script.render = render

export default script